import UnderlineCurve from 'components/curves/UnderlineCurve';
import { NextSeo } from 'next-seo';
import React from 'react';

import Footer from '../components/Footer';
import pages from '../config/pages';

function AboutPage() {
    return (
        <div className="single-page o-projektu pt-16">
            <NextSeo title={pages.about.title} description={pages.about.seo.description} />

            <section id="kaj-je-kzv" className="container text-center">
                <h1 className="text-brand ">
                    <UnderlineCurve color="#FFEACC" height={18}>
                        Kaj je kam za vikend?
                    </UnderlineCurve>
                </h1>
                <p className="max-w-md mx-auto mt-4">
                    Kam za vikend (KZV) je največja spletna zbirka idej za izlete po Sloveniji, ki omogoča preprosto
                    raziskovanje po regijah, občinah in tipih izletov.
                </p>
                <img src="/images/mountains.svg" alt="" className="w-full md:h-56" />
            </section>

            <div className="container md:grid grid-cols-12 gap-16 max-w-5xl mx-auto">
                <div className="col-span-7">
                    <section id="zakaj-kzv">
                        <h2 className="text-brand">
                            <UnderlineCurve color="#FFEACC" height={20}>
                                Zakaj razvijamo KZV?
                            </UnderlineCurve>
                        </h2>
                        <p className="mt-4 max-w-lg">
                            Ker si želimo delati nekaj, kar nas bo vodilo v naravo in med ljudi. In ker prevečkrat
                            poslušamo kako lepo je v tujini in kaj vse imajo tam in ker vemo, da imamo tudi v Sloveniji
                            ogromno pustolovskih in izletniških možnosti. Vsem želimo olajšati raziskovanje in
                            odkrivanje najbolj popularnih in najmanj znanih biserov Slovenije.
                        </p>
                    </section>
                    <section id="vizija-kzv" className="mt-8">
                        <h2 className="text-brand ">
                            <UnderlineCurve color="#FFEACC">Vizija KZV</UnderlineCurve>
                        </h2>
                        <p className="mt-4 max-w-lg">
                            Domačim in tujim gostom želimo ponuditi najboljšo iskalno izkušnjo izletniških idej po
                            Sloveniji. Vemo, da je kljub tisočim možnostim, ki jih nudi Slovenija, marsikdaj težko priti
                            do dobre ideje za izlet in do kakovostnih informacij, ki bi pomagale k dobri odločitvi. Zato
                            smo odločeni, da največjo zbirko idej za izlete po Sloveniji ves čas dograjujemo in jo
                            pripeljemo do najvišjega nivoja, ki ga omogoča razvoj tehnologije ter kakovostne, ažurne in
                            koristne informacije za vse uporabnike.
                        </p>
                    </section>
                    <section id="vrednote-kzv" className="mt-8">
                        <h2 className="text-brand">
                            <UnderlineCurve color="#FFEACC">KZV vrednote</UnderlineCurve>
                        </h2>
                        <p className="mt-4 max-w-lg">
                            Spoštovanje in simbioza z naravo ter sočlovekom. Izletništvo in turizem prinašata veliko
                            dobrih stvari, ampak se moramo ljudje zavedati, da s svojim ravnanjem in prisotnostjo v
                            naravi vplivamo na okolje. Naj bo naš vpliv čim manjši in prijazen do celotne narave.
                            Ustanovitelji KZV želimo z zgledom utrjevati pot takemu načinu razmišljanja.
                        </p>
                    </section>
                </div>
                <div className="hidden md:block col-span-5 pt-16">
                    <img src="/images/smerokaz.svg" alt="" className="w-full" />
                </div>
            </div>

            <section id="ekipa-kzv" className="pb-36 pt-24 container">
                <h1 className="text-brand text-center">
                    <UnderlineCurve color="#FFEACC" height={20}>
                        Ustanovitelji KZV
                    </UnderlineCurve>
                </h1>
                <p className="max-w-lg mx-auto mt-4 text-center">
                    Navdušeni smo nad slovensko naravo. Smo tudi rekreativni športniki, ki službeno preveč časa
                    preživimo v sedečem položaju za računalnikom.
                </p>

                <div className="space-y-8 md:space-y-0 md:grid grid-cols-3 gap-8 mt-6 max-w-5xl mx-auto">
                    <div className="flex items-start space-x-2 md:block md:space-x-0">
                        <img
                            src="/images/team/leon.jpg"
                            alt="Leon Škrilec - ustanovitelj portala Kam za vikend"
                            className="w-24 sm:w-52 md:w-auto"
                        />
                        <div>
                            <h4 className="font-serif text-xl mt-2">Leon Škrilec</h4>
                            <div className="text-secondary">Vodenje projekta in razvoj</div>
                            <p className="mt-4">
                                Leon vsak dan ohranja ravnotežje med časom preživetim za računalnikom in časom
                                preživetim v naravi. Tako kot ga navdušuje izdelovanje učinkovitih spletnih produktov,
                                ga navdušujejo najrazličnejše športne aktivnosti kot so smučanje, tenis, pohodništvo,
                                golf in tek.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4 md:block md:space-x-0">
                        <img
                            src="/images/team/ana.jpg"
                            alt="Ana logar - soustanoviteljica portala Kam za vikend"
                            className="w-24 sm:w-52 md:w-auto"
                        />
                        <div>
                            <h4 className="font-serif text-xl mt-2">Ana logar</h4>
                            <div className="text-secondary">Oblikovanje in družbena omrežja</div>
                            <p className="mt-4">
                                Ana je UI/UX oblikovalka v digitalnem studiu in v prostem času z družino (in kužkom)
                                najraje pobegne v naravo. Vsakič znova je navdušena nad lepotami Slovenije. Poleg
                                pohodništva najde tudi čas za jadranje, tenis, potapljanje in potovanja.
                            </p>
                        </div>
                    </div>
                    <div className="flex items-start space-x-4 md:block md:space-x-0">
                        <img
                            src="/images/team/jure.jpg"
                            alt="Jure Korenč - soustanovitelj portala Kam za vikend"
                            className="w-24 sm:w-52 md:w-auto"
                        />
                        <div>
                            <h4 className="font-serif text-xl mt-2">Jure Korenč</h4>
                            <div className="text-secondary">Vodenje skupnosti in tekstopisje</div>
                            <p className="mt-4">
                                Jure je kreativni direktor v oglaševalski agenciji in rekreativni plezalec in pohodnik,
                                narava pa mu diši veliko bolj, kot pisarna. Zmrazi ga, ko vidi smeti ležati v naravi.
                                Širijo pa se mu pljuča, ko vdihne svež gorski zrak, vonj borovcev ali ko zagleda katero
                                od tisočerih lepot Slovenije.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default AboutPage;
